import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {FC} from 'react';
import ScrollableList from '@/components/design-system/ScrollableList';

interface ProductProps {
  imgUrl: string;
  name: string;
  included: string[];
}

const Product: FC<ProductProps> = ({imgUrl, name, included}) => {
  const t = useTranslations('business.Index');
  return (
    <div className="flex-col group flex gap-3 h-full mx-4">
      <div className="bg-white rounded-md overflow-hidden shrink-0 py-2">
        <div className="relative sm:h-52 sm:w-full w-32 h-32 mx-auto">
          <Image
            fill
            className="object-contain"
            src={imgUrl || ''}
            alt={name}
          />
        </div>
      </div>
      <div className="space-y-0.5 text-left">
        <h3 className="text-base capitalize font-bold tracking-tight text-greyscale-body m-0 leading-5">
          {name}
        </h3>
        <div className="text-sm text-greyscale-label font-medium tracking-tight">
          <span>{t('whats-included')}</span>
          <ul className="list-disc m-0 text-xs">
            {included.map((elem, idx) => (
              <li key={idx}>{elem}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const SuggestedProducts: FC = () => {
  const t = useTranslations('business.Index');
  const products: ProductProps[] = [
    /*{
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod1.png`,
      name: t('suggested-prod.1.name'),
      included: [
        t('suggested-prod.1.1'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
     */
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod2.png`,
      name: t('suggested-prod.2.name'),
      included: [
        t('suggested-prod.2.1'),
        t('suggested-prod.2.2'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod3.png`,
      name: t('suggested-prod.3.name'),
      included: [
        t('suggested-prod.3.1'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod4.png`,
      name: t('suggested-prod.4.name'),
      included: [
        t('suggested-prod.4.1'),
        t('suggested-prod.4.2'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod7.png`,
      name: t('suggested-prod.5.name'),
      included: [
        t('suggested-prod.5.1'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
    /*
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod5.png`,
      name: t('suggested-prod.6.name'),
      included: [
        t('suggested-prod.6.1'),
        t('suggested-prod.6.2'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
     */
    {
      imgUrl: `${IMGPW}/business/regalistica_suggested/prod6.png`,
      name: t('suggested-prod.7.name'),
      included: [
        t('suggested-prod.7.1'),
        t('suggested-prod.0.1'),
        t('suggested-prod.0.2'),
        t('suggested-prod.0.3'),
        t('suggested-prod.0.4'),
      ],
    },
  ];

  return (
    <div className="section-container text-center pb-12 bg-greyscale-gray-lighter">
      <h2 className="mb-4 font-bold">{t('per-prendere-ispirazione')}</h2>
      <ScrollableList
        gap={8}
        autoPlay
        columns={{
          xxl: 4,
          xl: 4,
          lg: 4,
          md: 3,
          sm: 2,
          xs: 2,
        }}
        data={products}
        keyExtractor={(elem, index) => index.toString()}
        renderItem={(prod) => (
          <Product
            imgUrl={prod.imgUrl}
            included={prod.included}
            name={prod.name}
          />
        )}
      />
    </div>
  );
};

export default SuggestedProducts;
